export default {
    dark: "#1D1128",
    primary: "#7314ED",
    secondary: "#B486AB",
    light: "#E9E9E9"
};